module.exports = __webpack_public_path__ + "static/media/upload-light 1.e9cba910.svg";